import React, { useState, useEffect } from "react";
import logo from "src/assets/icon/logo.png";

function NavbarRegister() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 0);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav className={`navbarRegister ${scrolled ? "scrolled" : ""}`}>
      <a
        href="https://www.ghlogistica.com.br/"
        className="navbarRegisterBack"
      >
        Conheça a GH
      </a>
      <a
        href="https://ghlogistica.com.br/intermodal2026"
        className="navbarRegisterLogo"
      >
        <img src={logo} alt="GH Solucionador Logístico" width={180} />
      </a>
      <div className="navbarRegisterSpacer" />
    </nav>
  );
}

export default NavbarRegister;
